import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CustomLoader from "../../components/CustomeLoader";
import milionicon from "../../ulits/images/milion_icon.svg";
import petrolicon from "../../ulits/images/petrol_icon.svg";
import manualicon from "../../ulits/images/manual_icon.svg";
import googlepay from "../../ulits/images/google-pay.svg";
import staricon from "../../ulits/images/star-img.svg";
import carimg3 from "../../ulits/images/car_img3.png";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import { Pagination, Autoplay, FreeMode, EffectFade } from "swiper/modules";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  blogAction,
  configAction,
  faqAction,
  homeAction,
  pageAction,
} from "../../_actions";
import { status } from "../../_constants/commonLhd";
import { configs } from "../../config";
import whatsapp from "../../ulits/images/WatSapp-icon.svg";
import parse from "html-react-parser";
import tiktok from "../../ulits/images/tiktok_icon.svg";
import instagram from "../../ulits/images/Instagram_icon.svg";
import snapchat from "../../ulits/images/Snapchat_icon.svg";
import facebook from "../../ulits/images/Facebook_icon.svg";
// import image from "../../ulits/images/home-car-img.png";
// import tabimg5 from "../../ulits/images/tab_img5.png";
import dateicon from "../../ulits/images/date-icon.svg";
import location_icon from "../../ulits/images/location_icon.svg";
import Accordion from "react-bootstrap/Accordion";
// Import Swiper styles
import "swiper/css/free-mode";
import "swiper/css/autoplay";
import { Helmet } from "react-helmet";
import { Modal } from "react-bootstrap";
import settings from "../../ulits/images/setting_icon.svg";
import Cookies from "js-cookie";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);
function Home() {
  const [loader, setLoading] = useState(true);
  const [activeButtonIndex, setActiveButtonIndex] = useState(1);
  const [modal, setModal] = useState(!Cookies.get("cookiesAccepted"));
  const [isValidate, setIsValidate] = useState(false);
  const [credentials, setCredentials] = useState({
    email: "",
  });
  const [cars, setCars] = useState([]);
  const [seo, setSeo] = useState({});
  const [brands, setBrands] = useState([]);
  const [aboutData, setAboutData] = useState();
  const [topBanner, setTopBanner] = useState({});
  const [blog, setBlog] = useState([]);
  const [faq, setFaq] = useState({});
  const config = localStorage.getItem("config")
    ? JSON.parse(localStorage.getItem("config"))
    : null;

  const navigate = useNavigate();

  const dispatch = useDispatch();
  const homeData = useSelector((state) => state.home);
  const faqData = useSelector((state) => state.faq);

  useEffect(() => {
    dispatch(homeAction.getBrandsByTenantId());
    dispatch(homeAction.getCarsByTenantId());
    dispatch(homeAction.getTopBannerDetail()); dispatch(homeAction.getTopBannerDetail());
    dispatch(faqAction.getFaqDetails());
    dispatch(blogAction.getBlogDetail());
  }, [dispatch]);

  const seoData = useSelector((state) => state.config);

  const settings = {
    centerMode: false,
    arrows: false,
    centerPadding: "60px",
    slidesToShow: 3,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: false,
          // centerPadding: "40px",
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerMode: false,
          centerPadding: "40px",
          slidesToShow: 1,
        },
      },
    ],
  };

  useEffect(() => {
    if (seoData && seoData.seo_status === status.SUCCESS) {
      setSeo(seoData.seo_data);
    }
  }, [seoData]);

  const blogData = useSelector((state) => state.blog);

   useEffect(() => {
      if (blogData && blogData.blog_status === status.SUCCESS) {
  
        const activeBlogs = blogData.blog_data.filter(
          blog => blog.status === true
        );
        setBlog(activeBlogs);
      }
  
    }, [blogData]);
  

  useEffect(() => {
    if (homeData && homeData.car_status === status.SUCCESS) {

      const activeCars = homeData.car_data.filter(
        car => car.status === true
      );

      setCars(activeCars);
    }

  }, [homeData]);


  useEffect(() => {
    if (homeData && homeData.brands_status === status.SUCCESS) {

      const activeBrands = homeData.brands_data.filter(
        brands => brands.status === true
      );
      console.log(323, homeData.brands_data);
      setBrands(activeBrands);
    }

  }, [homeData]);

  useEffect(() => {
    if (homeData && homeData.top_banner_status === status.SUCCESS) {

      const activeBanners = homeData.top_banner_data.filter(
        banner => banner.status === true
      );

      setTopBanner(activeBanners);
    }

  }, [homeData]);

  useEffect(() => {
    if (faqData && faqData.faq_status === status.SUCCESS) {
      const activeFaq = faqData.faq_data.filter(
        faq => faq.status === true
      );
      setFaq(activeFaq);
    }
  }, [faqData]);


  useEffect(() => {
    if (homeData && homeData.email_status === status.SUCCESS) {
    }
  }, [homeData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials({
      ...credentials,
      [name]: value,
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => {
      setLoading(false);
    }, 600);
  }, []);

  const validateCredentials = (isValidate) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const validObj = {
      message: "",
      isValid: true,
    };

    let isValid = true;
    const retData = {
      email: validObj,
      isValid,
    };

    if (isValidate) {
      const { email } = credentials;

      if (!email) {
        retData.email = {
          message: "Email is required",
          isValid: false,
        };
        isValid = false;
      } else if (!emailRegex.test(email)) {
        retData.email = {
          message: "Please enter a valid email address",
          isValid: false,
        };
        isValid = false;
      }

      retData.isValid = isValid;
      return retData;
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const error = validateCredentials(true);
    setIsValidate(true);
    if (error.isValid) {
      dispatch(homeAction.sendEmail(credentials));
      setCredentials({ email: "" });
      setIsValidate(false);
      navigate("/");
    }
  };

  const handleButtonClick = (buttonLink) => {
    if (!buttonLink) return;

    if (buttonLink.startsWith("http://") || buttonLink.startsWith("https://")) {
      window.open(buttonLink, "_blank");
    } else if (buttonLink.startsWith("www.")) {
      window.open(`https://${buttonLink}`, "_blank");
    } else {
      navigate(buttonLink);
    }
  };


  const aboutChooseData = useSelector((state) => state.page);

  useEffect(() => {
    if (aboutChooseData && aboutChooseData.about_status === status.SUCCESS)
      setAboutData(aboutChooseData.about_data);
  }, [aboutChooseData]);

  useEffect(() => {
    dispatch(pageAction.getAboutChooseData());
  }, [dispatch]);

  const error = validateCredentials(isValidate);

  const isDesktop = window.innerWidth > 768;
  const gap = isDesktop ? 0.0285 * window.innerWidth : 15;

  const handleModalClose = () => {
    setModal(false);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";

    const [datePart] = dateString.split(",");
    const [day, month, year] = datePart.split("/");

    const date = new Date(`${year}-${month}-${day}`);
    const dayNum = date.getDate();
    const monthName = date
      .toLocaleString("en-GB", { month: "long" })
      .toUpperCase();
    const yearNum = date.getFullYear();

    const suffix = (d) => {
      if (d > 3 && d < 21) return "th";
      switch (d % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    };

    return `${dayNum}${suffix(dayNum)} ${monthName} ${yearNum}`;
  };

  const getUniqueSlug = (slug) => {
    let count = 0;
    blog.forEach((blogs) => {
      if (blogs.slug === slug) {
        count++;
      }
    });

    if (count > 1) {
      let newSlug = `${slug}-${count - 1}`;
      return newSlug;
    }
    return slug;
  };

  const [reviews, setReviews] = useState([]);
  const [rating, setRating] = useState(0);
  const [totalReviews, setTotalReviews] = useState(0);

  // Render dynamic stars based on rating
  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

    for (let i = 0; i < fullStars; i++) {
      stars.push(<span key={`full-${i}`} style={{ color: '#FBBC04', fontSize: '20px' }}>★</span>);
    }
    if (hasHalfStar) {
      stars.push(<span key="half" style={{ color: '#FBBC04', fontSize: '20px' }}>★</span>);
    }
    for (let i = 0; i < emptyStars; i++) {
      stars.push(<span key={`empty-${i}`} style={{ color: '#E0E0E0', fontSize: '20px' }}>★</span>);
    }

    return <div style={{ display: 'flex', gap: '2px' }}>{stars}</div>;
  };

  useEffect(() => {
    async function fetchReviews() {
      try {
        const response = await fetch(` ${configs.localApiUrl}/reviews?placeId=${config?.Google_PlaceId}`);
        const data = await response.json();
        console.log("Google API Response:", data);
        setReviews(data.reviews || []);
        setRating(data.rating || 0);
        setTotalReviews(data.totalReviews || (data.reviews ? data.reviews.length : 0));
      } catch (err) {
        console.error("Error fetching Google reviews:", err);
      }
    }

    if (config?.Google_PlaceId) {
      fetchReviews();
    }
  }, []);



  return (
    <>
      <Helmet>
        <meta name="description" content={seo && seo.Home_Meta_Description} />
        <meta name="keywords" content={seo && seo.Home_Meta_Keywords} />
      </Helmet>
      {loader ? (
        <CustomLoader />
      ) : (
        <div className="main-wrapper">
          <div className="home-col-section first">
            <div className="col-text blue-bg">
              {topBanner &&
                topBanner.length > 0 &&
                topBanner.map((item, index) => (
                  <div className="our-courses-box">
                    <div className="date-inner-title">
                      <div className="date-title">
                        <h2>{item.title}</h2>
                        <p>{parse(item.description)}</p>
                        <button
                          className="primary-btn sm"
                          onClick={() => handleButtonClick(item.buttonLink)}
                        >
                          {item.buttonText}
                          <div className="arrow-icon"></div>
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
            <div className="col-image">
              {topBanner &&
                topBanner.length > 0 &&
                topBanner.map((item, index) => (
                  <div className="our-courses-box">
                    <img
                      src={`${configs.localApiUrl}${item.image}`}
                      alt="home-col-1"
                    />
                  </div>
                ))}
              <div className="WatSapp-icon">
                <div className="whatsapp-icon">
                  <Link
                    to={`https://wa.me/${config?.Contact_Number?.replace(/\D/g, '')}`}
                    target="_blank"
                  >
                    <img src={whatsapp} alt="whatsapp" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="home-new-section second">
            <div className="col-image">
              <div className="container">
                <div className="date-inner-title containe">
                  <div className="date-title">
                    <h1>NEW IN</h1>
                  </div>
                  <div className="box-wrapper">
                    {cars &&
                      cars
                        ?.slice()
                        .sort((a, b) => {
                          const dateA = dayjs(a.createdAt, "DD/MM/YYYY, hh:mm:ss a");
                          const dateB = dayjs(b.createdAt, "DD/MM/YYYY, hh:mm:ss a");
                          return dateB.valueOf() - dateA.valueOf();
                        })
                        .slice(0, 9)
                        .map((cars, index) => (
                          <div
                            className="box"
                            key={index}
                            onClick={() =>
                              navigate(`/car-details/${cars.slug}`, {
                                state: cars,
                              })
                            }
                            style={{ cursor: "pointer" }}
                          >
                            <img
                              src={`${configs.localApiUrl}${cars.image[0]}`}
                              alt="home-col-1"
                              className="box-image"
                              style={{ cursor: "pointer" }}
                            />
                            <div className="box-content-inner">
                              <div className="box-content">
                                <h1>{cars && cars.details.toUpperCase()}</h1>
                                <ul>
                                  <li>
                                    <Link to="#">
                                      <img src={milionicon} alt="arrow-icon" />
                                      {/* {cars.mileage} MILES */}
                                      {Number(cars.mileage).toLocaleString(
                                        "en-IN"
                                      )}{" "}
                                      MILES
                                    </Link>
                                  </li>
                                  <li>
                                    <Link to="#">
                                      <img src={petrolicon} alt="arrow-icon" />
                                      {cars && cars.fuelType.toUpperCase()}
                                    </Link>
                                  </li>
                                  <li>
                                    <Link to="#">
                                      <img src={manualicon} alt="arrow-icon" />
                                      {cars &&
                                        cars.transmission.toUpperCase() ===
                                        "AUTOMATIC"
                                        ? "AUTO"
                                        : cars.transmission.toUpperCase() ===
                                          "SEMI AUTOMATIC"
                                          ? "SEMI AUTO"
                                          : cars.transmission}
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                              <button className="primary-btn sm">
                                £{Number(cars.price).toLocaleString("en-IN")}
                              </button>
                            </div>
                          </div>
                        ))}
                  </div>
                  <button
                    className="primary-btn-list"
                    onClick={() => navigate("/car-listing")}
                  >
                    FULL STOCK LIST
                  </button>
                </div>
              </div>
            </div>
            <div className="home-choose-us-section">
              <div className="container">
                <div className="heading-title">
                  <h1>{aboutData && aboutData.Title}</h1>
                </div>
                <div className="choose-us-box">
                  <div className="choose-us-wrapper">
                    <div className="choose-us-box">
                      <div className="choose-us-content">
                        <img
                          src={`${configs.localApiUrl}${(aboutData && aboutData.Logo_1) || ""
                            }`}
                          alt="tab-icon"
                        />
                        <h2>{aboutData && aboutData.Blog_1_Title }</h2>
                  
                        {aboutData && typeof aboutData.Blog_1_Description === "string"
                          ? parse(aboutData && aboutData.Blog_1_Description)
                          : null}
                      </div>
                      <div className="choose-us-icon">
                        <img
                          src={`${configs.localApiUrl}${(aboutData && aboutData.blog1Image) || ""
                            }`}
                          alt="car-icon"
                        />
                      </div>
                    </div>
                    <div className="choose-us-box">
                      <div className="choose-us-content">
                        <img
                          src={`${configs.localApiUrl}${aboutData && aboutData.Logo_2
                            }`}
                          alt="tab-icon"
                        />
                          <h2>{aboutData && aboutData.Blog_2_Title }</h2>
                        {aboutData && typeof aboutData.Blog_2_Description === "string"
                          ? parse(aboutData && aboutData.Blog_2_Description)
                          : null}
                      </div>
                      <div className="choose-us-icon">
                        <img
                          src={`${configs.localApiUrl}${aboutData && aboutData.blog2Image
                            }`}
                          alt="car-icon"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="choose-us-wrapper">
                    <div className="choose-us-box">
                      <div className="choose-us-content">
                        <img
                          src={`${configs.localApiUrl}${(aboutData && aboutData.Logo_3) || ""
                            }`}
                          alt="tab-icon"
                        />
                          <h2>{aboutData && aboutData.Blog_3_Title }</h2>
                        {aboutData && typeof aboutData.Blog_3_Description === "string"
                          ? parse(aboutData && aboutData.Blog_3_Description)
                          : null}
                      </div>
                      <div className="choose-us-icon">
                        <img
                          src={`${configs.localApiUrl}${aboutData && aboutData.blog3Image
                            }`}
                          alt="car-icon"
                        />
                      </div>
                    </div>
                    <div className="choose-us-box">
                      <div className="choose-us-content">
                        <img
                          src={`${configs.localApiUrl}${(aboutData && aboutData.Logo_4) || ""
                            }`}
                          alt="tab-icon"
                        />
                        <h2>{aboutData && aboutData.Blog_4_Title }</h2>
                        {aboutData && typeof aboutData.Blog_4_Description === "string"
                          ? parse(aboutData && aboutData.Blog_4_Description)
                          : null}
                      </div>
                      <div className="choose-us-icon">
                        <img
                          src={`${configs.localApiUrl}${aboutData && aboutData.blog4Image
                            }`}
                          alt="car-icon"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="blog-listing-section">
              <div className="container">
                <div className="heading-title">
                  <h1>ALL ABOUT LHD</h1>
                </div>
                <div className="blog-listing-wrapper">
                  {blog && blog.length > 0 ? (
                    blog.slice(0, 3).map((item, index) => {
                      const uniqueSlug = getUniqueSlug(item.slug, item);
                      // console.log("Blog Item:", item);
                      // console.log("Blog Item:", item.title);
                      return (
                        <div className="choose-us-box" key={index}>
                          <div className="blog-listing-box">
                            <div className="blog-listing-content">
                              <div className="blog-listing-img">
                                <img
                                  src={`${configs.localApiUrl}${item?.image}`}
                                  alt="blog-img"
                                />
                              </div>
                              <div className="blog-listing-title">
                                <h1>{item.title}</h1>
                                <p>
                                  {item && item.description
                                    ? parse(item.description)
                                    : null}
                                </p>
                                <div className="meta-middle-unit">
                                  <div className="blog-listing-date">
                                    <img src={dateicon} alt="" />
                                    <span>
                                      {item?.createdAt &&
                                        formatDate(item.createdAt)}
                                    </span>
                                  </div>
                                  <div className="blog-listing-date">
                                    <img src={location_icon} alt="location" />
                                    <span>{item && item.location}</span>
                                  </div>
                                </div>
                                <button
                                  className="primary-btn sm"
                                  onClick={() =>
                                    navigate(`blog-details/${uniqueSlug}`)
                                  }
                                >
                                  READ MORE
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <>No Blog Data</>
                  )}
                </div>
              </div>
            </div>

            <div className="google-review-section">
              <div className="container">
                <div className="heading-title">
                  <h1>GOOGLE REVIEWS</h1>
                </div>
                <div className="google-review-wrapper-box">
                  <div className="u-wrapper">
                    <div>
                      <Swiper
                        modules={[Autoplay, FreeMode]}
                        spaceBetween={10}
                        speed={5000}
                        direction="horizontal"
                        autoplay={{ delay: 0, disableOnInteraction: false }}
                        loop={true}
                        freeMode={true}
                        slidesPerView={3}
                        breakpoints={{
                          320: { slidesPerView: 1.1 },
                          640: { slidesPerView: 1.1 },
                          1040: { slidesPerView: 3 },
                        }}
                      >
                        <div>
                          <Slider {...settings}>
                            {reviews?.map((review, index) => (
                              <div key={index}>
                                <div className="google-review-box">
                                  <div className="google-review-img">
                                    {renderStars(review.rating || 5)}
                                    <img
                                      src={googlepay}
                                      alt="google-logo"
                                      className="star-icon"
                                    />
                                  </div>
                                  <div className="google-review-content">
                                    <h2>{review.relative_time_description}</h2>
                                    <p>{review.text}</p>
                                    <h2>{review.author_name}</h2>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </Slider>
                        </div>
                      </Swiper>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="join-our-section">
              <div className="join-title">
                <div className="container join-title-inner">
                  <h1>JOIN OUR NEWSLETTER NOW</h1>
                  <form className="join-form" onSubmit={handleSubmit}>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={credentials.email}
                      onChange={handleChange}
                      placeholder="Enter your email address"
                      className="form-control"
                      required
                    />
                    <div
                      type="submit"
                      className="arrow-icons"
                      onClick={handleSubmit}
                    ></div>
                  </form>
                  {error && error.email.message !== "" && (
                    <div className="error-message" style={{ color: "red" }}>
                      {error.email.message}
                    </div>
                  )}
                </div>
                <div className="join-img">
                  <img
                    src={`${configs.localApiUrl}${config?.Newsletter_image}`}
                    alt="join-img"
                  />
                </div>
              </div>
            </div>
            <div className="follow-us-section">
              <div className="col-image">
                <img src={carimg3} alt="follow-img" />
              </div>
              <div className="col-content">
                <h2>FOLLOW US ON SOCIALS</h2>
                <ul>
                  <li>
                    <Link
                      to={
                        config && config?.Tiktok_Url ? config?.Tiktok_Url : "#"
                      }
                    >
                      <img src={tiktok} alt="tiktok_icon" />
                      {/* <img
                        src={`${configs.localApiUrl}${config?.tiktokLogo}`}
                        alt="tiktok_icon"
                        onClick={() => window.open(config?.Tiktok_Url)}
                      /> */}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={
                        config && config?.Snapchat_Url
                          ? config?.Snapchat_Url
                          : "#"
                      }
                    >
                      <img src={snapchat} alt="snapchat_icon" />
                      {/* <img
                        src={`${configs.localApiUrl}${config?.snapchatLogo}`}
                        alt="snapchat_icon"
                        onClick={() => window.open(config?.Snapchat_Url)}
                      />  */}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={
                        config && config?.Instagram_Url
                          ? config?.Instagram_Url
                          : "#"
                      }
                    >
                      <img src={instagram} alt="instagram_icon" />
                      {/* <img
                        src={`${configs.localApiUrl}${config?.instagramLogo}`}
                        alt="instagram_icon"
                        onClick={() => window.open(config?.Instagram_Url)}
                      />  */}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={
                        config && config?.Facebook_Url
                          ? config?.Facebook_Url
                          : "#"
                      }
                    >
                      <img src={facebook} alt="facebook_icon" />
                      {/* <img
                        src={`${configs.localApiUrl}${config?.fecebookLogo}`}
                        alt="facebook_icon"
                        onClick={() => window.open(config?.Facebook_Url)}
                      />  */}
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="brands-stock text-center">
              <div className="head-title">
                <h2>BRANDS WE WORK WITH</h2>
                <div className="u-wrapper d-none d-md-block">
                  <div className="c-carousel">
                    <Swiper
                      modules={[Autoplay]}
                      spaceBetween={10}
                      speed={2000}
                      direction="horizontal"
                      autoplay={{
                        delay: 0,
                        disableOnInteraction: false,
                      }}
                      loop={true}
                      slidesPerView={7.5}
                      freeMode={true}
                      breakpoints={{
                        320: {
                          slidesPerView: 1,
                          speed: 5000,
                        },
                        768: {
                          slidesPerView: 1,
                        },
                        1024: {
                          slidesPerView: 7.5,
                        },
                      }}
                    >
                      {brands.map((brands) => (
                        <SwiperSlide>
                          <img
                            src={`${configs.localApiUrl}${brands.brandImage}`}
                            alt="Slide 1"
                            key={brands.id}
                          />
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>
                </div>
                <div className="u-wrapper d-none d-md-block">
                  <div className="c-carousel">
                    <Swiper
                      modules={[Autoplay]}
                      spaceBetween={10}
                      speed={2000}
                      direction="horizontal"
                      autoplay={{
                        delay: 0,
                        disableOnInteraction: false,
                        reverseDirection: true,
                      }}
                      loop={true}
                      slidesPerView={7.5}
                      freeMode={true}
                      breakpoints={{
                        320: {
                          slidesPerView: 1,
                          speed: 5000,
                        },
                        768: {
                          slidesPerView: 1,
                        },
                        1024: {
                          slidesPerView: 7.5,
                        },
                      }}
                    >
                      {brands.map((brands) => (
                        <SwiperSlide>
                          <img
                            src={`${configs.localApiUrl}${brands.brandImage}`}
                            alt="Slide 1"
                            key={brands.id}
                          />
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>
                </div>
                <div className="u-wrapper d-block d-md-none">
                  <div className="c-carousel">
                    <Swiper
                      modules={[Autoplay]}
                      direction="horizontal"
                      loop={true}
                      freeMode={true}
                      freeModeMomentum={false}
                      slidesPerView="auto"
                      spaceBetween={gap}
                      speed={4000}
                      watchSlidesProgress={true}
                      watchSlidesVisibility={true}
                      autoplay={{
                        delay: 1,
                        disableOnInteraction: false,
                      }}
                      cssMode={false}
                    >
                      {brands.map((brands) => (
                        <SwiperSlide>
                          <img
                            src={`${configs.localApiUrl}${brands.brandImage}`}
                            alt="Slide 1"
                            key={brands.id}
                          />
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>
                </div>
                <div className="u-wrapper d-block d-md-none">
                  <div className="c-carousel">
                    <Swiper
                      modules={[Autoplay]}
                      direction="horizontal"
                      loop={true}
                      freeMode={true}
                      freeModeMomentum={false}
                      slidesPerView="auto"
                      spaceBetween={gap}
                      speed={4000}
                      watchSlidesProgress={true}
                      watchSlidesVisibility={true}
                      autoplay={{
                        delay: 1,
                        reverseDirection: true,
                      }}
                      cssMode={false}
                    >
                      {brands.map((brands) => (
                        <SwiperSlide>
                          <img
                            src={`${configs.localApiUrl}${brands.brandImage}`}
                            alt="Slide 1"
                            key={brands.id}
                          />
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>
                </div>
              </div>
            </div>
            <div className="stm-accordion-single-unit">
              <div className="container">
                <div className="stm-accordion-title">
                  <h3>FREQUENTLY ASKED QUESTIONS</h3>
                </div>
                {faq &&
                  faq.length > 0 &&
                  faq.map((item, index) => (
                    <Accordion key={index}>
                      <Accordion.Item eventKey={index.toString()}>
                        <Accordion.Header>{item.que}</Accordion.Header>
                        <Accordion.Body>{item.ans}</Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  ))}
              </div>
            </div>
          </div>
        </div>
      )}
      <Modal
        show={modal}
        onHide={() => {
          handleModalClose();
        }}
        className="cookies-modal"
      >
        <Modal.Body>
          <div className="cookies-container">
            <h1>WE USE COOKIES</h1>
            <p>
              Click Accept to allow The Left Hand Drive Car Showroom Ltd to use
              cookies to personalise this site, and to deliver ads and measure
              their effectiveness on other apps and websites, including social
              media. Customise your preferences in your cookie settings or click
              Reject if you do not want us to use cookies for this purpose.
              Learn more in our <Link to="/terms">Cookie Notice.</Link>
            </p>
            <div className="car-list-btn">
              <button
                title="Reject"
                className={`primary-btn sm  ${activeButtonIndex === "0" ? "active" : ""
                  }`}
                onClick={() => {
                  Cookies.remove("cookiesAccepted");
                  setActiveButtonIndex("Reject");
                  handleModalClose();
                  setModal(false);
                }}
              >
                Reject
              </button>

              <button
                title="Accept"
                className={`primary-btn sm  ${activeButtonIndex === "1" ? "active" : ""
                  }`}
                onClick={() => {
                  Cookies.set("cookiesAccepted", "true", { expires: 365 });
                  setActiveButtonIndex("Accept");
                  handleModalClose();
                  setModal(false);
                }}
              >
                Accept
              </button>
            </div>
            {/* <div className="settings_icon">
              <img src={settings} alt="settings" />
              <h5>Cookie settings</h5>
            </div> */}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Home;
